import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchFun } from '../../../../utils/fetchFun';
import { zeroOnlyEntries } from '../../../../utils/helperFunctions';

export const fetchChecksReports = createAsyncThunk(
    'user/fetchChecksReports',
    async ({user}) => {
        try {
            const checksReport = await fetchFun(`/api/v1/checks?userId=${user?._id}`);
            if(checksReport?.success) {
                const filteredData = zeroOnlyEntries(checksReport?.data?.body)
                const updatedResponse = {
                    ...checksReport,
                    data:{...checksReport?.data,
                    body: filteredData}
				};
                
                return updatedResponse?.data
            }
        } catch(error) {
            console.log("Error - /checks", error)
        }
    }
)